import { render, staticRenderFns } from "./AddPropertyChangeRequest.vue?vue&type=template&id=7092ad54"
import script from "./AddPropertyChangeRequest.vue?vue&type=script&lang=ts"
export * from "./AddPropertyChangeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports